var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-6" }, [
    _c("div", { staticClass: "grid grid-cols-3 gap-6" }, [
      _c(
        "div",
        { staticClass: "col-span-2" },
        [
          _c("section-panel", { attrs: { heading: "Items" } }, [
            _c(
              "table",
              { staticClass: "w-full" },
              [
                _c("tr", [
                  _c("th", { staticClass: "font-medium text-left px-4 pb-4" }, [
                    _vm._v("Item"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "w-px font-medium text-right px-4 pb-4" },
                    [_vm._v("Price")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "w-px font-medium text-center px-4 pb-4" },
                    [_vm._v("Quantity")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    { staticClass: "w-px font-medium text-right px-4 pb-4" },
                    [_vm._v("Subtotal")]
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.order.items, function (item) {
                  return [
                    _c(
                      "tr",
                      {
                        staticClass: "border-t border-gray-200 first:border-0",
                      },
                      [
                        _c(
                          "td",
                          { staticClass: "text-left px-4 pt-4 align-top" },
                          [
                            _c("div", { staticClass: "flex items-start" }, [
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "font-semibold uppercase mb-1 -mt-1 pb-2",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(item.name) +
                                        "\n                                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                item.is_event
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-gray-500 text-sm font-medium leading-5 pb-2",
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "Date: " +
                                              _vm._s(
                                                item.event_date
                                                  .start_date_no_time
                                              )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-right px-4 pt-4 align-top" },
                          [_vm._v("£" + _vm._s(item.formatted_price))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-center px-4 pt-4 align-top" },
                          [_c("div", [_vm._v(_vm._s(item.quantity))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-right px-4 pt-4 align-top" },
                          [_vm._v("£" + _vm._s(item.formatted_total))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(item.sub_items, function (subItem) {
                      return _c(
                        "tr",
                        { staticClass: "text-sm text-gray-500" },
                        [
                          _c(
                            "td",
                            { staticClass: "text-left px-4 pb-2 align-top" },
                            [
                              _c("div", { staticClass: "flex items-start" }, [
                                _c("div", [
                                  _c("div", { staticClass: "mb-1 -mt-1" }, [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(subItem.name) +
                                        "\n                                            "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "text-right px-4 pb-2 align-top whitespace-no-wrap",
                            },
                            [_vm._v("+£" + _vm._s(subItem.formatted_price))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-center px-4 pb-2 align-top" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(subItem.quantity) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "text-right px-4 pb-2 align-top whitespace-no-wrap",
                            },
                            [_vm._v("+£" + _vm._s(subItem.formatted_total))]
                          ),
                        ]
                      )
                    }),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "w-full" },
              [
                _vm._l(
                  _vm.order.formatted_additional_charges,
                  function (charge) {
                    return _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass:
                            "px-4 py-2 align-top border-t border-gray-100",
                          attrs: { colspan: "3" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(charge.name) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass:
                            "text-right px-4 py-2 align-top border-t border-gray-100",
                        },
                        [_vm._v("£" + _vm._s(charge.formatted_amount))]
                      ),
                    ])
                  }
                ),
                _vm._v(" "),
                _vm.order.membership_discount > 0
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass:
                            "px-4 py-2 align-top border-t border-gray-100",
                          attrs: { colspan: "3" },
                        },
                        [
                          _vm._v(
                            "\n                                Membership Discount\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass:
                            "text-right px-4 py-2 align-top border-t border-gray-100",
                        },
                        [
                          _vm._v(
                            "- £" +
                              _vm._s(_vm.order.formatted_membership_discount)
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.credit_transaction
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass:
                            "px-4 py-2 align-top border-t border-gray-100",
                          attrs: { colspan: "3" },
                        },
                        [
                          _vm._v(
                            "\n                                Account Credit\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass:
                            "text-right px-4 py-2 align-top border-t border-gray-100",
                        },
                        [
                          _vm._v(
                            "\n                                - £" +
                              _vm._s(
                                _vm.order.credit_transaction.formatted_amount.replace(
                                  "-",
                                  ""
                                )
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass:
                        "px-4 py-2 align-top border-t border-dashed border-gray-100 font-semibold",
                      attrs: { colspan: "3" },
                    },
                    [
                      _vm._v(
                        "\n                                Total\n                            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass:
                        "text-right px-4 py-2 align-top border-t border-b border-gray-100 font-semibold",
                    },
                    [_vm._v("£" + _vm._s(_vm.orderTotal))]
                  ),
                ]),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.vouchers.length > 0
            ? _c(
                "section-panel",
                { staticClass: "mt-6", attrs: { heading: "Vouchers" } },
                [
                  _c(
                    "table",
                    { staticClass: "w-full" },
                    [
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "font-medium text-left px-4 pb-4" },
                          [_vm._v("Code")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass:
                              "w-px font-medium text-right px-4 pb-4",
                          },
                          [_vm._v("Amount")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass:
                              "w-px font-medium text-center px-4 pb-4",
                          },
                          [_vm._v("Status")]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.vouchers, function (voucher) {
                        return _c(
                          "tr",
                          {
                            staticClass:
                              "border-t border-gray-200 first:border-0",
                          },
                          [
                            _c(
                              "td",
                              { staticClass: "text-left px-4 pt-4 align-top" },
                              [_vm._v(_vm._s(voucher.hyphenated_code))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "right px-4 pt-4 align-top" },
                              [_vm._v("£" + _vm._s(voucher.formatted_amount))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "text-left px-4 pt-4 align-top whitespace-no-wrap",
                              },
                              [
                                _c(
                                  "badge",
                                  {
                                    staticClass: "ml-3 whitespace-no-wrap",
                                    attrs: {
                                      color: voucher.has_been_redeemed
                                        ? "green"
                                        : "red",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          voucher.has_been_redeemed
                                            ? "Redeemed"
                                            : "Un-redeemed"
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.order.notes.length > 0
            ? _c(
                "h4",
                {
                  staticClass:
                    "text-lg leading-6 text-gray-900 px-4 py-5 mt-6 mb-5 border-b border-gray-200",
                },
                [_vm._v("\n                    Notes\n                ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-10" },
            _vm._l(_vm.order.notes, function (note) {
              return _c(
                "div",
                { staticClass: "border-b border-gray-200 last:border-0" },
                [
                  _c(
                    "div",
                    { staticClass: "grid grid-cols-4 gap-10 text-sm p-4" },
                    [
                      _c("div", { staticClass: "col-span-3" }, [
                        note.notify_customer
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "font-semibold text-primary-600 mb-1",
                              },
                              [
                                _vm._v(
                                  "\n                                    Customer Notified\n                                "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(_vm.nl2br(note.body)) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-right" }, [
                        _c("div", [
                          _vm._v(_vm._s(note.formatted_created_date)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "font-medium" }, [
                          _vm._v(_vm._s(note.made_by.name)),
                        ]),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("description-list", {
            attrs: {
              heading: "Billing Information",
              "list-items": [
                {
                  name: "Name",
                  value: `${_vm.order.billing_first_name} ${_vm.order.billing_last_name}`,
                },
                {
                  name: "Address",
                  value: `${_vm.order.billing_address_1}<br>${_vm.order.billing_address_2}<br>${_vm.order.billing_town}<br>${_vm.order.billing_county}<br>${_vm.order.billing_post_code}`,
                },
              ],
            },
          }),
          _vm._v(" "),
          _c("description-list", {
            staticClass: "mt-6",
            attrs: {
              heading: "Contact Information",
              "list-items": [
                { name: "Email", value: _vm.order.customer.email },
                { name: "Phone", value: _vm.order.customer.phone },
              ],
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }